import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Stack,
  Button,
  Box,
  Divider,
} from '@mui/material'
import {
  Close as CloseIcon,
  Phone as PhoneIcon,
  WhatsApp as WhatsAppIcon,
  Email as EmailIcon,
} from '@mui/icons-material'

interface BookingContactModalProps {
  open: boolean
  onClose: () => void
  roomName?: string
}

const PHONE = '+91 7978190633'
const PHONE_RAW = '917978190633'
const EMAIL = 'hotelbisworupainn@gmail.com'

const BookingContactModal = ({ open, onClose, roomName }: BookingContactModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        <Typography variant="h6" sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
          Book Your Stay
        </Typography>
        {roomName && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {roomName}
          </Typography>
        )}
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', top: 12, right: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          To reserve a room, please reach out to us directly via phone, WhatsApp, or email. We'll confirm your booking right away!
        </Typography>

        <Stack spacing={2}>
          <Button
            variant="contained"
            startIcon={<PhoneIcon />}
            href={`tel:${PHONE_RAW}`}
            component="a"
            fullWidth
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              py: 1.3,
              fontSize: '1rem',
              fontWeight: 600,
            }}
          >
            Call Us &nbsp;·&nbsp; {PHONE}
          </Button>

          <Button
            variant="contained"
            startIcon={<WhatsAppIcon />}
            href={`https://wa.me/${PHONE_RAW}${roomName ? `?text=${encodeURIComponent(`Hi, I'd like to book the ${roomName}. Please let me know the availability.`)}` : ''}`}
            target="_blank"
            rel="noopener noreferrer"
            component="a"
            fullWidth
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              py: 1.3,
              fontSize: '1rem',
              fontWeight: 600,
              bgcolor: '#25D366',
              '&:hover': { bgcolor: '#1ebe5d' },
            }}
          >
            WhatsApp &nbsp;·&nbsp; {PHONE}
          </Button>

          <Divider>
            <Typography variant="caption" color="text.secondary">or</Typography>
          </Divider>

          <Box
            component="a"
            href={`mailto:${EMAIL}${roomName ? `?subject=${encodeURIComponent(`Room Booking Enquiry – ${roomName}`)}` : ''}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'text.secondary',
              textDecoration: 'none',
              justifyContent: 'center',
              '&:hover': { color: 'primary.main' },
            }}
          >
            <EmailIcon fontSize="small" />
            <Typography variant="body2">{EMAIL}</Typography>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default BookingContactModal
